// Vanilla Web Component – kein externer Import nötig
class StepMarqueeComponent extends HTMLElement {
  connectedCallback() {
    // CSS-Keyframe-Motion deaktivieren, damit JS exklusiv steuert
    this.setAttribute('data-disabled', '');

    // Refs
    this.wrapper = this.querySelector('.marquee__wrapper');
    this.content = this.querySelector('.marquee__content');
    this.track   = this.querySelector('.marquee__repeated-items');
    if (!this.wrapper || !this.content || !this.track) return;

    // Items
    this.items = Array.from(this.track.children);
    if (!this.items.length) return;

    this.index = 0;
    this.#readGap();
    this.#setItemSizes();
    this.#apply(0); // Start bei 0 → erster Text sichtbar

    // Nur loopen, wenn wirklich mehr als 1 „echtes“ Item existiert
    const uniqueCount = this.#effectiveUniqueItemCount(this.items);
    if (uniqueCount > 1) this.#startLoop();

    // Events
    this._onResize = () => {
      this.#readGap();
      this.#setItemSizes();
      this.#apply(this.index);
    };
    window.addEventListener('resize', this._onResize);

    this._onVisibility = () => {
      if (document.hidden) this.#clearLoop();
      else if (!this._interval && uniqueCount > 1) this.#startLoop();
    };
    document.addEventListener('visibilitychange', this._onVisibility);
  }

  disconnectedCallback() {
    this.#clearLoop();
    window.removeEventListener('resize', this._onResize);
    document.removeEventListener('visibilitychange', this._onVisibility);
  }

  // ----- helpers -----

  #measureViewportWidth() {
    // Immer die Breite des <marquee-component> verwenden
    // → entspricht dem sichtbaren Bereich, unabhängig vom Wrapper
    return Math.round(this.clientWidth);
  }

  #readGap() {
    const cs = getComputedStyle(this.track);
    // „gap“ kann „Xpx“ oder „Xpx Ypx“ sein → parseFloat nimmt den ersten Wert
    this.gap = Math.round(parseFloat(cs.gap) || 0);
  }

  #setItemSizes() {
    const vw = this.#measureViewportWidth();
    this.items.forEach((el) => {
      el.style.flex = `0 0 ${vw}px`;
      el.style.width = `${vw}px`;
    });
    // Safety: Startposition
    this.wrapper.style.transform = 'translate3d(0,0,0)';
    // Smooth transform
    this.content.style.willChange = 'transform';
    this.content.style.transition = 'transform 0.3s ease-in-out';
  }

  #startLoop() {
    this.#clearLoop();
    const factor = parseInt(this.getAttribute('data-speed-factor') || '20', 10);
    const delay = Math.max(1000, Math.round(50000 / Math.max(1, factor))); // kleiner Faktor = langsamer
    this._interval = setInterval(() => {
      this.index = (this.index + 1) % this.items.length; // durch alle Items inkl. Duplikate
      this.#apply(this.index);
    }, delay);
  }

  #clearLoop() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }

  #apply(idx) {
    const vw = this.#measureViewportWidth();
    const step = vw + this.gap;                // Schrittbreite = Viewport + gap
    const dirAttr = (this.getAttribute('data-movement-direction') || 'normal').toLowerCase();
    const sign = dirAttr === 'reverse' ? 1 : -1;
    const offset = sign * (step * idx);

    // Auf ganze Pixel snappen, um Drift durch Subpixel zu verhindern
    const snapped = Math.round(offset);
    this.content.style.transform = `translate3d(${snapped}px, 0, 0)`;
  }

  #effectiveUniqueItemCount(items) {
    const n = items.length;
    if (n <= 1) return n;
    const half = Math.floor(n / 2);
    const a = items.slice(0, half).map((el) => el.outerHTML).join('');
    const b = items.slice(half, half * 2).map((el) => el.outerHTML).join('');
    return a && a === b ? half : n;
  }
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', StepMarqueeComponent);
}
